export class CustomFloating {
  constructor() {

    this.content1();
    this.contact1();
  }

  content1() {
    this._content1FloatingSecondary = document.querySelectorAll('.floating-el_content-1--secondary');
    if (this._content1FloatingSecondary) {
      this._content1FloatingSecondary.forEach((el) => {
        let element = document.createElement('div');
        element.classList.add('floating-el_content--added');
        element.innerHTML = `<svg width="210" height="682" viewBox="0 0 210 682" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M-539 494L-364.182 0.552108L209.626 72.8186L-6.10052 681.734L-539 494Z" fill="#E00512"/>
</svg>`;
        el.appendChild(element);
      });
    }
  }

  contact1() {
    this._contact1FloatingSecondary = document.querySelectorAll('.floating-el_contact-1--secondary');
    console.log(this._contact1FloatingSecondary);
    if (this._contact1FloatingSecondary) {
      this._contact1FloatingSecondary.forEach((el) => {
        let element = document.createElement('div');
        element.classList.add('floating-el_contact1--added');
        element.innerHTML =
          `<svg width="541" height="682" viewBox="0 0 541 682" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 494L174.818 0.552108L748.626 72.8186L532.899 681.734L0 494Z" fill="#E00512"/>
          </svg>`;
        el.appendChild(element);
      })
    }
  }
}
